{
    "IN-AP": { "latitude": 15.9129, "longitude": 79.73999 },
    "IN-AR": { "latitude": 28.2184, "longitude": 94.7278 },
    "IN-AS": { "latitude": 26.2006, "longitude": 92.9376 },
    "IN-BR": { "latitude": 25.0961, "longitude": 85.3131 },
    "IN-CH": { "latitude": 30.7333, "longitude": 76.7794 },
    "IN-CT": { "latitude": 21.2787, "longitude": 81.8661 },
    "IN-DL": { "latitude": 28.7041, "longitude": 77.1025 },
    "IN-GA": { "latitude": 15.2993, "longitude": 74.124 },
    "IN-GJ": { "latitude": 22.2587, "longitude": 71.1924 },
    "IN-HR": { "latitude": 29.0588, "longitude": 76.0856 },
    "IN-HP": { "latitude": 31.1048, "longitude": 77.1734 },
    "IN-JK": { "latitude": 33.7782, "longitude": 76.5762 },
    "IN-JH": { "latitude": 23.6102, "longitude": 85.2799 },
    "IN-KA": { "latitude": 15.3173, "longitude": 75.7139 },
    "IN-KL": { "latitude": 10.8505, "longitude": 76.2711 },
    "IN-LA": { "latitude": 34.1526, "longitude": 77.5771 },
    "IN-MP": { "latitude": 23.2599, "longitude": 77.4126 },
    "IN-MH": { "latitude": 19.7515, "longitude": 75.7139 },
    "IN-MN": { "latitude": 24.6637, "longitude": 93.9063 },
    "IN-ML": { "latitude": 25.467, "longitude": 91.3662 },
    "IN-MZ": { "latitude": 23.1645, "longitude": 92.9376 },
    "IN-NL": { "latitude": 26.1584, "longitude": 94.5624 },
    "IN-OR": { "latitude": 20.9517, "longitude": 85.0985 },
    "IN-PY": { "latitude": 11.9416, "longitude": 79.8083 },
    "IN-PB": { "latitude": 31.1471, "longitude": 75.3412 },
    "IN-RJ": { "latitude": 27.0238, "longitude": 74.2179 },
    "IN-SK": { "latitude": 27.533, "longitude": 88.5122 },
    "IN-TN": { "latitude": 11.1271, "longitude": 78.6569 },
    "IN-TG": { "latitude": 18.1124, "longitude": 79.0193 },
    "IN-TR": { "latitude": 23.9408, "longitude": 91.9882 },
    "IN-UP": { "latitude": 26.8467, "longitude": 80.9462 },
    "IN-UT": { "latitude": 30.0668, "longitude": 79.0193 },
    "IN-WB": { "latitude": 22.9868, "longitude": 87.855 },
    "IN-AN": { "latitude": 11.7401, "longitude": 92.6586 },
    "IN-DN": { "latitude": 20.1809, "longitude": 73.0169 },
    "IN-LD": { "latitude": 10.5667, "longitude": 72.6417 }
}


